import React from 'react';

import { ToggleButtonGroup } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const ToggleButtonGroupField = withFormField()(({ area, ...props }) => {
  return (
    <ToggleButtonGroup
      size={'small'}
      color={'primary'}
      {...omitFormProps(props)}
    />
  );
});
export default ToggleButtonGroupField;
